import { NAMESPACE_ENUM } from '@/components/shared/file-list/file-list.service';
import { Ppm } from '@/types';

export const getPPMPVItems = (ppm: Ppm) => {
  return {
    'Procès verbal CPMP': { items: ppm?.pvCpmp || [], nameSpace: NAMESPACE_ENUM.PV },
    'Extraits Procès verbal CPMP': { items: ppm?.extraitCpmp || [], nameSpace: NAMESPACE_ENUM.SNIPPET },
    'Documents examinés/Justifs CPMP': {
      items: ppm?.documentCPMP || [],
      nameSpace: NAMESPACE_ENUM.MEETING_PPM,
    },
    'Procès verbal CNCMP Permanente': { items: ppm?.pvCncmpPermanente || [], nameSpace: NAMESPACE_ENUM.PV },
    'Extraits Procès verbal CNCMP Permanente': {
      items: ppm?.extraitCncmpPermanente || [],
      nameSpace: NAMESPACE_ENUM.SNIPPET,
    },
    'Documents examinés/Justifs CNCMP Permanente': {
      items: ppm?.documentCNCMPPermanente || [],
      nameSpace: NAMESPACE_ENUM.MEETING_PPM,
    },
    'Procès verbal CNCMP Spécialisée': { items: ppm?.pvCncmpSpecialisee || [], nameSpace: NAMESPACE_ENUM.PV },
    'Documents examinés/Justifs CNCMP Spécialisée': {
      items: ppm?.documentCNCMPSpecialisee || [],
      nameSpace: NAMESPACE_ENUM.MEETING_PPM,
    },
  };
};
